 const retiringLaunchpadItems = [
    
    {
        colour:"card-red",
        icon:<svg viewBox="0 0 24 24"><path className="fill-red" d="M22.5 16H20.3L22 12H17V18H19V23L22.5 16M15 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V10H20V4H4V16H10V19.1L13.1 16H15V18Z"></path></svg>,
        title:"Live Stats Dashboard",
        description:"Todays live data from across all of your Stations, worldwide.",
        route:"/live_dashboard.html",
        toHTML: true,
        id:34,
        order:1,
        requiredRole: "manager"
    },
    {
        colour:"card-pink",
        icon:<svg viewBox="0 0 24 24"><path className="fill-pink" d="M13,3V9H21V3M13,21H21V11H13M3,21H11V15H3M3,13H11V3H3V13Z"></path></svg>,
        title:"Historic Key Statistics",
        description:"Account wide Key Statistics. Understand current performance.",
        route:"/dashboard.html",
        toHTML: true,
        id:89,
        order:2,
        requiredRole: "manager"
    },
    {
        colour:"card-purple",
        icon:<svg viewBox="0 0 24 24"><path className="fill-purple" d="M2.5,19H21.5V21H2.5V19M9.68,13.27L14.03,14.43L19.34,15.85C20.14,16.06 20.96,15.59 21.18,14.79C21.39,14 20.92,13.17 20.12,12.95L14.81,11.53L12.05,2.5L10.12,2V10.28L5.15,8.95L4.22,6.63L2.77,6.24V11.41L4.37,11.84L9.68,13.27Z"></path></svg>,
        title:"Station Map - Task Stats",
        description:"A map of subjects/stations - showing station task performance in summary and detail form",
        route:"/map.html",
        toHTML: true,
        id:37612,
        order:3,
        requiredRole: "manager"
    },
    {
        colour:"card-slate",
        icon:<svg viewBox="0 0 24 24"><path className="fill-slate" d="M22.5 16H20.3L22 12H17V18H19V23L22.5 16M15 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V10H20V4H4V16H10V19.1L13.1 16H15V18Z"></path></svg>,
        title:"Tasks by Station",
        description:"A detailed view of the historic task data generated at each station.",
        route:"/stations.html",
        toHTML: true,
        id:29871,
        order:4,
        requiredRole: "viewer"
    },
    {
        colour:"card-dark-blue",
        icon:<svg viewBox="0 0 24 24"><path className="fill-dark-blue" d="M13 19.88C13.04 20.18 12.94 20.5 12.72 20.71C12.32 21.1 11.69 21.1 11.3 20.71L7.29 16.7C7.06 16.47 6.96 16.16 7 15.87V10.75L2.21 4.62C1.87 4.19 1.95 3.56 2.38 3.22C2.57 3.08 2.78 3 3 3H17C17.22 3 17.43 3.08 17.62 3.22C18.05 3.56 18.13 4.19 17.79 4.62L13 10.75V19.88M5.04 5L9 10.07V15.58L11 17.58V10.05L14.96 5H5.04M17.75 21L15 18L16.16 16.84L17.75 18.43L21.34 14.84L22.5 16.25L17.75 21"></path></svg>,
        title:"Filterable Stats Overview",
        description:"A filterable view of the overview stats task. Giving the ability to exclude selected tasks from the stats.",
        route:"/task-dashboard.html",
        toHTML: true,
        id:98798,
        order:5,
        requiredRole: "manager"
    }
]
export default retiringLaunchpadItems
